<mat-card class="knso-card">
    <mat-card-header>
        <mat-toolbar>
            <span>Port Out Voucher</span>
            <button mat-icon-button (click)="cancel()"><mat-icon>close</mat-icon></button>
          </mat-toolbar>
    </mat-card-header>
    <mat-card-content>
    
      <div class="flex">
        Are you sure you want to mark the voucher as a port-out? This cannot be undone.
        Please select a Housing Authority to port out to.
      </div>
      <p flex="30" class="text-right marg-right-1 flex-30"><strong>Housing Authority*</strong></p>
      <p flex="60" class="ng-binding flex-60">
        <mat-form-field class="voucher-full-width">
            <input 
                type="text" 
                placeholder="Start typing the name of the Housing Authority"
                aria-label="Housing Authority" 
                matInput
                [formControl]="vendorCtrl" 
                [matAutocomplete]="vendorAuto"/>
            <mat-autocomplete #vendorAuto="matAutocomplete" [displayWith]="vendorSelectDisplay"  (optionSelected)="onVendorSelected($event)">
                <mat-option *ngFor="let ll of filteredVendors$ | async;" 
                    [value]="ll">
                    <span>{{ll.name}}</span>
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
      </p>
    </mat-card-content>
    <mat-card-actions>
        <div class="bottom-buttons">
            <button mat-button (click)="cancel()" class="hds_button" type="button" [(disabled)]="spinnerCheck">
                Cancel
            </button>
            <button mat-button class="hds_button" type="submit" [disabled]="!selectedAuthorityId || spinnerCheck" (click)="save()">
                Confirm
            </button>
        </div>
    </mat-card-actions>
</mat-card>
